import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0848a3e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "images" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "privacy-terms" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "address" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All rights reserved. ", -1))
const _hoisted_17 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.companyInfo.socialUrls['fb'])
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.companyInfo.socialUrls['fb'],
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/icons/fb-icon.svg`),
              alt: "facebook icon svg"
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.companyInfo.socialUrls['insta'])
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: _ctx.companyInfo.socialUrls['insta'],
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/icons/ig-icon.svg`),
              alt: "instagram icon svg"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.companyInfo.socialUrls['youtube'])
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: _ctx.companyInfo.socialUrls['youtube'],
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/icons/yt-icon.svg`),
              alt: "youtube icon svg"
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.companyInfo.termsUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.companyInfo.termsUrl
          }, "Terms and Conditions", 8, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.companyInfo.termsUrl)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " | "))
        : _createCommentVNode("", true),
      (_ctx.companyInfo.privacyUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: _ctx.companyInfo.privacyUrl
          }, "Privacy Policy", 8, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_13, [
      _createTextVNode(_toDisplayString(_ctx.addressString) + " ", 1),
      (_ctx.companyInfo.email)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: 'mailto:' + _ctx.companyInfo.email
          }, _toDisplayString(_ctx.companyInfo.email), 9, _hoisted_14))
        : _createCommentVNode("", true)
    ]),
    _hoisted_15,
    _createElementVNode("span", null, "© " + _toDisplayString(_ctx.companyInfo.name) + " 2024. ", 1),
    _hoisted_16,
    (_ctx.companyInfo.website)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.companyInfo.website,
          target: "_blank"
        }, " View our full website.", 8, _hoisted_17))
      : _createCommentVNode("", true)
  ]))
}